import { IChangePropertyPayload } from '@dash/editForm';
import actionsTypes from './actionTypes';
import {
  AddNewSkillAction,
  BulkUploadWorkersErrorAction,
  BulkUploadWorkersRequestAction,
  BulkUploadWorkersSuccessAction,
  ChangeModalVisibilityAction,
  ChangePositionAction,
  ChangePropertyAction,
  ChangeTierAction,
  ClearStateAction,
  ProcessActionErrorAction,
  ProcessActionRequestAction,
  ProcessActionSuccessAction,
  RemoveSkillAction,
} from './actions.d';
import {
  Attribute,
  IBulkUploadWorkersPayload,
  IChangePositionPayload,
  IChangeTierPayload,
  IFieldTypes,
  IProcessActionErrorPayload,
  IProcessActionSuccessPayload,
  IProcessRequestPayload,
  IRemoveSkillPayload,
} from './types';

const actions = {
  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  processActionSuccess: (payload: IProcessActionSuccessPayload): ProcessActionSuccessAction => ({
    type: actionsTypes.PROCESS_ACTION_SUCCESS,
    payload,
  }),

  processActionError: (payload: IProcessActionErrorPayload): ProcessActionErrorAction => ({
    type: actionsTypes.PROCESS_ACTION_ERROR,
    payload,
  }),

  changeModalVisibility: (): ChangeModalVisibilityAction => ({
    type: actionsTypes.CHANGE_MODAL_VISIBILITY,
  }),

  changeProperty: (payload: IChangePropertyPayload<Attribute, IFieldTypes>): ChangePropertyAction => ({
    type: actionsTypes.CHANGE_PROPERTY,
    payload,
  }),

  addNewSkill: (): AddNewSkillAction => ({
    type: actionsTypes.ADD_NEW_SKILL,
  }),

  changePosition: (payload: IChangePositionPayload): ChangePositionAction => ({
    type: actionsTypes.CHANGE_POSITION,
    payload,
  }),

  changeTier: (payload: IChangeTierPayload): ChangeTierAction => ({
    type: actionsTypes.CHANGE_TIER,
    payload,
  }),

  bulkUploadWorkersRequest: (payload: IBulkUploadWorkersPayload): BulkUploadWorkersRequestAction => ({
    type: actionsTypes.BULK_UPLOAD_WORKERS_REQUEST,
    payload,
  }),

  bulkUploadWorkersSuccess: (): BulkUploadWorkersSuccessAction => ({
    type: actionsTypes.BULK_UPLOAD_WORKERS_SUCCESS,
  }),

  bulkUploadWorkersError: (): BulkUploadWorkersErrorAction => ({
    type: actionsTypes.BULK_UPLOAD_WORKERS_ERROR,
  }),

  removeSill: (payload: IRemoveSkillPayload): RemoveSkillAction => ({
    type: actionsTypes.REMOVE_SKILL,
    payload,
  }),

  clearState: (): ClearStateAction => ({
    type: actionsTypes.CLEAR_STATE,
  }),
};

export default actions;
